/**
 * MenuDetailContainer
 * --
 */
import React from 'react';
import MenuDetailPresenter from './MenuDetailPresenter';

const MenuDetailContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <MenuDetailPresenter />
    </>
  );
};

export default MenuDetailContainer;
